import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills.jsx';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { fetchSkills, fetchProjects } from './services/api';
import './App.css';

function App() {
  const [skills, setSkills] = useState([]);
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const fetchedSkills = await fetchSkills();
        const fetchedProjects = await fetchProjects();
        setSkills(fetchedSkills);
        setProjects(fetchedProjects);
      } catch (error) {
        // console.error('Failed to load data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen" role="status" aria-label="Loading portfolio">
        <div className="loading-spinner" aria-hidden="true"></div>
        <p className="loading-text">Loading</p>
      </div>
    );
  }
  
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Skills skills={skills} />
      <Projects projects={projects} />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;